import * as classnames from 'classnames'
import * as React from 'react'

import { config } from '../../../common/config'
import ui from '../../../common/constants/ui'
import EnhancedLazyLoad from '../../components/enhancedLazyLoad'
import * as styles from './saleSash.module.css'

interface IProps {
  large?: boolean
  lazy?: boolean
}

const srcUrl = `${config.assets.PUBLIC_PATH}/images/sale-sash.svg`

const SaleSash = (props: IProps) => {
  const saleSashClass = classnames(styles.root, {
    [styles.large]: props.large
  })

  const image = <img className={saleSashClass} alt="Sale" src={srcUrl} />

  if (props.lazy) {
    return (
      <EnhancedLazyLoad height="100%" once offset={ui.lazyLoadOffset}>
        {image}
      </EnhancedLazyLoad>
    )
  }

  return image
}

export default SaleSash
